import React, { useState } from "react";
import { connect } from "react-redux";

// Reactstrap
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

// Components
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

// Services
import { createForm } from "../../../utils/services/rsvp";

function DuplicateForm({ isOpen, toggle, selectedForm, updateList, state }) {
  const jwt = state.global_user_data.data.token;

  // State de formulário
  const [formName, setFormName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Reseta os campos do formulário
  const resetFields = () => {
    setFormName("");
    setError("");
  };

  // Duplica o formulário e fecha o modal
  const handleSubmit = async () => {
    if (!formName.trim()) {
      setError("O campo nome do formulário deve ser preenchido");
      return;
    }

    const data = {
      json: selectedForm.json,
      eventId: selectedForm.eventId,
      description: formName,
    };

    setIsLoading(true);
    const response = await createForm({ jwt, data });
    setIsLoading(false);

    if (!response || response.status >= 400) {
      setError("Erro ao duplicar formulário. Tente novamente.");
      return;
    }

    await updateList();
    resetFields();
    toggle();
  };

  return (
    <Modal centered isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Duplicar Formulário</ModalHeader>
      <ModalBody>
        <Label>Nome do novo Formulário</Label>
        <Input
          type="text"
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
        />
        {error && <span className="text-danger">{error}</span>}
        <div className="save-btn-form-container">
          <Button
            color="danger"
            style={{ width: 80 }}
            onClick={toggle}
          >
            Fechar
          </Button>
          <ButtonSpinner
            isLoading={isLoading}
            title="Salvar"
            onClick={handleSubmit}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(DuplicateForm);
